// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2iPIl","icon":"style_icon__2P3Ss"};